import {IBizCoupon, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {ACoupon} from "@/views/editor/service/coupon/coupon";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";

export default class Coupon extends ACoupon implements IBizCoupon {

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }

    subs(status: EActivityStatus): CheckboxOptionType[] {
        return [{value: 'group_leader', label: '团长券'}]
    }

    resetMeta(status: EActivityStatus): IBusiness {
        this.meta.subs.length = 0
        this.meta.subs.push(...this.subs(status).map(s => s.value as string));
        return this;
    }

    set(owner: string, coupons: unknown[]) {
        console.log(owner, coupons);
        this.meta.subs.push('group_leader');
    }
}